import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  insightsLoadSuccess,
  insightsLoadFailure,
  insightsReloadSuccess,
  INSIGHTS_LOAD,
  INSIGHTS_RELOAD,
  InsightsLoadAction,
  InsightsReloadAction
} from './actions'
import { InsightsQueryParams, Report } from './types'

const buildQueryParams = (
  startDate?: string,
  endDate?: string
): InsightsQueryParams => ({
  ...(startDate ? { startDate } : {}),
  ...(endDate ? { endDate } : {})
})

const normalizeReports = (items: Report[]): Report[] =>
  items.map(item => ({
    ...item,
    reportType: 'Executive Summary'
  }))

export function* insightsLoadSaga(
  action: InsightsLoadAction
): Generator<any, void, any> {
  const { accountId, startDate, endDate } = action

  try {
    // NOTE: The start and end dates are not currently used by the backend API, but are included for future compatibility
    const params = buildQueryParams(startDate, endDate)

    const response = yield call(() =>
      axios.get(`/accounts/${accountId}/insights`, { params })
    )

    const insights = normalizeReports(response.data || [])

    yield put(insightsLoadSuccess(accountId, insights))
  } catch (error) {
    console.error('Insights load error:', error)
    yield put(insightsLoadFailure(accountId, error))
  }
}

export function* insightsReloadSaga(
  action: InsightsReloadAction
): Generator<any, void, any> {
  const { accountId, startDate, endDate } = action

  try {
    // NOTE: The start and end dates are not currently used by the backend API, but are included for future compatibility
    const params = buildQueryParams(startDate, endDate)

    const response = yield call(() =>
      axios.get(`/accounts/${accountId}/insights`, { params })
    )

    const insights = normalizeReports(response.data || [])

    yield put(insightsReloadSuccess(accountId, insights))
  } catch (error) {
    console.error('Insights reload error:', error)
    // Silent fail on reload
  }
}

export function* watch(): Generator<any, void, any> {
  yield all([
    takeLatest(INSIGHTS_LOAD, insightsLoadSaga),
    takeLatest(INSIGHTS_RELOAD, insightsReloadSaga)
  ])
}
